var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79686 7.11074H10.8774V8.69763H10.921C11.3515 7.92799 12.3988 7.11074 13.9639 7.11074C17.215 7.11074 17.816 9.13402 17.816 11.7663V17.3322H14.6046V12.3851C14.6046 11.2525 14.5808 9.79456 12.9344 9.79456C11.288 9.79456 11.0063 11.0264 11.0063 12.3038V17.3422H7.79686V7.11074ZM5.97393 4.01236C5.97393 4.34269 5.87598 4.6656 5.69245 4.94027C5.50893 5.21493 5.24808 5.429 4.94289 5.55541C4.63771 5.68183 4.30189 5.7149 3.9779 5.65046C3.65391 5.58601 3.35631 5.42694 3.12273 5.19336C2.88915 4.95978 2.73008 4.66218 2.66564 4.33819C2.60119 4.01421 2.63427 3.67839 2.76068 3.3732C2.88709 3.06801 3.10117 2.80716 3.37583 2.62364C3.65049 2.44012 3.97341 2.34216 4.30374 2.34216C4.74654 2.34269 5.17106 2.51882 5.48416 2.83193C5.79727 3.14504 5.97341 3.56955 5.97393 4.01236ZM2.63751 7.11074H5.97393V17.3322H2.63751V7.11074Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInGrayIcon);
export default __webpack_public_path__ + "static/media/LinkedIn_gray_icon.ccca22339864ead87bd0b5a7d725c4f2.svg";
export { ForwardRef as ReactComponent };